/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'framework-ui-components/Components/Icons/Icon';
import { PopOver } from 'framework-ui-components';

const NOOP = () => { };

// con il framerow-ui-components 1.8.15 è possibile usare l'icona standard
const FileIcon = Icon(
  <path d="M15.475,6.692l-4.084-4.083C11.32,2.538,11.223,2.5,11.125,2.5h-6c-0.413,0-0.75,0.337-0.75,0.75v13.5c0,0.412,0.337,0.75,0.75,0.75h9.75c0.412,0,0.75-0.338,0.75-0.75V6.94C15.609,6.839,15.554,6.771,15.475,6.692 M11.5,3.779l2.843,2.846H11.5V3.779z M14.875,16.75h-9.75V3.25h5.625V7c0,0.206,0.168,0.375,0.375,0.375h3.75V16.75z" />,
  '0 0 18 18',
  'FileIcon',
);

export default function CellaNumeroNoteDichiarazione({ numeroNote, onClick }) {
  // eventuale Badge   <Badge info className="dashboard-riga-dichiarazione__badge-numero-note">{numeroNote}</Badge>
  const tooltip = numeroNote === 1 ? 'Esiste una nota' : `Esistono ${numeroNote} note`;
  return (
    <td onClick={onClick}>
      {numeroNote > 0 ? (
        <div className="dashboard-riga-dichiarazione__cella-numero-note">
          <PopOver content={tooltip}>
            <FileIcon className="button--icon dashboard-riga-icon-numero-note" />
          </PopOver>
        </div>
      ) : undefined}
    </td>
  );
}

CellaNumeroNoteDichiarazione.propTypes = {
  numeroNote: PropTypes.number,
  onClick: PropTypes.func,
};

CellaNumeroNoteDichiarazione.defaultProps = {
  numeroNote: 0,
  onClick: NOOP,
};
